(function () {
  const accordionSelector = ".bb-product-detail .product__accordion--single-open details";
  const initializedAttribute = "data-bb-single-open-accordion";

  const syncSummaryState = (details) => {
    const summary = details.querySelector("summary");
    if (summary) {
      summary.setAttribute("aria-expanded", details.open ? "true" : "false");
    }
  };

  const init = (root = document) => {
    const accordions = Array.from(root.querySelectorAll(accordionSelector));

    accordions.forEach((details) => {
      if (details.hasAttribute(initializedAttribute)) return;
      details.setAttribute(initializedAttribute, "true");
      syncSummaryState(details);

      details.addEventListener("toggle", () => {
        syncSummaryState(details);
        if (!details.open) return;

        accordions.forEach((sibling) => {
          if (sibling === details || !sibling.open) return;
          sibling.open = false;
          syncSummaryState(sibling);
        });
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
